export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_PATTERN = /^\d{1,12}$/;

export const rolesOptionsAccount = [
  {
    name: "I'am a*",
    value: "I'am a*",
  },
  { name: 'Architect', value: 'Architect' },
  { name: 'Interior Designer', value: 'Interior Designer' },
  { name: 'Specifier', value: 'Specifier' },
  { name: 'Builder', value: 'Builder' },
  { name: 'Plumber', value: 'Plumber' },
  { name: 'Merchant', value: 'Merchant' },
  { name: 'Project Manager', value: 'Project Manager' },
  { name: 'Contractor', value: 'Contractor' },
  { name: 'Developer', value: 'Developer' },
  { name: 'Surveyor', value: 'Surveyor' },
  { name: 'Estimator', value: 'Estimator' },
  { name: 'Renovator', value: 'Renovator' },
  { name: 'Other', value: 'Other' },
];

export const rolesOptions = [
  {
    name: 'Your role*',
    value: 'Your role*',
  },
  { name: 'Architect', value: 'Architect' },
  { name: 'Interior Designer', value: 'Interior Designer' },
  { name: 'Specifier', value: 'Specifier' },
  { name: 'Builder', value: 'Builder' },
  { name: 'Plumber', value: 'Plumber' },
  { name: 'Merchant', value: 'Merchant' },
  { name: 'Project Manager', value: 'Project Manager' },
  { name: 'Contractor', value: 'Contractor' },
  { name: 'Developer', value: 'Developer' },
  { name: 'Surveyor', value: 'Surveyor' },
  { name: 'Estimator', value: 'Estimator' },
  { name: 'Renovator', value: 'Renovator' },
  { name: 'Other', value: 'Other' },
];

export const companyTypeOptions = [
  {
    name: 'Company type*',
    value: 'Company type*',
  },
  { name: 'Builder', value: 'Builder' },
  { name: 'Plumber', value: 'Plumber' },
  { name: 'Merchant', value: 'Merchant' },
  { name: 'Developer', value: 'Developer' },
  { name: 'Architect', value: 'Architect' },
  { name: 'Designer', value: 'Designer' },
  { name: 'Other', value: 'Other' },
];

export const countryOptionsAU = [
  {
    name: 'Country*',
    value: 'Country*',
  },
  {
    name: 'Australia',
    value: 'Australia',
  },
];
export const countryOptionsNZ = [
  {
    name: 'Country*',
    value: 'Country*',
  },
  {
    name: 'New Zealand',
    value: 'New Zealand',
  },
];

export const stateOptionsAU = [
  {
    name: 'State*',
    value: 'State*',
  },
  { name: 'ACT', value: 'ACT' },
  { name: 'NSW', value: 'NSW' },
  { name: 'NT', value: 'NT' },
  { name: 'QLD', value: 'QLD' },
  { name: 'SA', value: 'SA' },
  { name: 'TAS', value: 'TAS' },
  { name: 'VIC', value: 'VIC' },
  { name: 'WA', value: 'WA' },
];
export const stateOptionsNZ = [
  {
    name: 'State*',
    value: 'State*',
  },
  { name: 'North Island', value: 'North Island' },
  { name: 'South Island', value: 'South Island' },
];
